import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="download-file-link"
export default class extends Controller {
  
  close() {
    this.element.remove();
  }
  
}
